import * as R from 'ramda'
import {
    FETCH_TAG_COLORS_SUCCESS
} from '../actionTypes'

const InitialState = [];

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case FETCH_TAG_COLORS_SUCCESS:
            return payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/tagColors.js